import {
    ALERT_DO_ACKNOWLEDGE,
    ALERTS_POLL_EVENTS, ALERTS_SET_CURRENT_CAMERA,
    ALERTS_SET_EVENTS, ALERTS_SET_SELECTED_CAMERA, ALERTS_SET_SORTING_EVENTS, ALERTS_STOP_POLL_EVENTS, ALERT_ADD_EVENT_CASE, ALERTS_SET_ALARM_SCENARIO
} from "./constants";

import {
    AlertsPullEventsAction, AlertsSetCurrentCameraAction,
    AlertsSetEventsAction, AlertsSetSelectEventAction, AlertsSetSortingEventsAction, EventType, AlertsSetAlarmScenarioList
} from "./types";
import {CameraDataInterface} from "../cameras/types";
import { IAlarmScenariosInfo } from "../../services/cayuga/types";

export const runPollEvents = () : AlertsPullEventsAction => ({type: ALERTS_POLL_EVENTS});

export const stopPollEvents = () => ({type: ALERTS_STOP_POLL_EVENTS});

export const setEvents = (playSound: boolean | null, transactionId?: string, events?: EventType[]) : AlertsSetEventsAction =>
    ({type: ALERTS_SET_EVENTS, transactionId, events, playSound});

export const setSortingEvents = (direction: number, type: string) : AlertsSetSortingEventsAction =>
    ({type: ALERTS_SET_SORTING_EVENTS, sorting: {direction, type}});

export const setSelectedEvent = (event: EventType | null) : AlertsSetSelectEventAction =>
    ({type: ALERTS_SET_SELECTED_CAMERA, event});

export const setCurrentCamera = (camera: CameraDataInterface | null) : AlertsSetCurrentCameraAction =>
    ({type: ALERTS_SET_CURRENT_CAMERA, camera});

export const setAlarmScenarioList = (scenarioList: IAlarmScenariosInfo[]) : AlertsSetAlarmScenarioList =>
    ({type: ALERTS_SET_ALARM_SCENARIO, scenarioList});

export const doAcknowledgeEvent = (eventDescr: any) => ({type: ALERT_DO_ACKNOWLEDGE, eventDescr});

export const AddEventCase = (name: string, comment: string) => ({type: ALERT_ADD_EVENT_CASE, name, comment});


